<template>
  <div v-on:mouseover="mouseEnter" v-on:click="click" v-on:mouseleave="mouseLeave" v-bind:style="[currentStyle]">
    <div class="dot__item" v-bind:class="clZObj"></div>
  </div>
</template>

<script>
export default {
    name: 'dot',
    props: {
        tag: {
            type: Object,
            default: function () {
                return {
                   id: null,
                   meta: {},
                   scenes: [],
                   name: ''
                }
            }
        },
        dimensions: Object,
        frames: Array,
        duration: Number,
        currentFrame: Number
    },
    methods: {
        click: function(e) {
            this.$emit('activate')
        },
        mouseEnter(e) {
            this.$emit('activate')
        },
        mouseLeave(e) {
            // this.$emit('hideTag', this.dot)
        }
    },
    computed: {
        dot: function () {
            return this.frames[this.currentFrame]
        },
        clZObj: function () {
            return {
                pulse: true
            }
        },
        currentPosition: function() {
            if (!this.dot || !this.dimensions.w || !this.dimensions.h) return { x: -1000, y: -1000 }
            return {
                x: this.dot.x * this.dimensions.w,
                y: this.dot.y * this.dimensions.h
            }
        },
        currentStyle: function () {
            const style = {
                display: this.currentPosition.x > -8 && this.currentPosition.y > -8 ? 'initial' : 'none',
                'background-color': 'rgba(128, 0, 128, 0.9)',
                // transition: this.currentPosition.x > -8 && this.currentPosition.y > -8 ? 'transform 100ms linear' : 'none',
                transform: `translate(${this.currentPosition.x}px, ${this.currentPosition.y}px)`
            }
            return style
        }
    }
  }
</script>
<style scoped lang="scss">

</style>
